const GAPS = {
  none: '0',
  'page-content': '3rem',
  content: '2rem',
  composite: '1.25rem',
  atom: '0.75rem',
  primitive: '0.5rem',
  'sub-primitive': '0.25rem',
} as const;

export type Gap = keyof typeof GAPS;

const gapName = <T extends Gap>(gap: T) => `--theme-${gap}-gap` as const;

export const gapVar = <T extends Gap>(gap: T) =>
  `var(${gapName(gap)})` as const;

export default Object.entries(GAPS)
  .map(([name, value]) => `${gapName(name as Gap)}: ${value};`)
  .join('');
